<template>
  <section class="addons">
    <ModuleSection
      :id="`_${$options.name}`"
      title="Optional: Ihr Firmenlogo ergänzen"
      icon='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"><g><path d="M10.56,4.22a1.21,1.21,0,0,0-1.74,0l-7,7a3.71,3.71,0,0,0,0,5.23l3.49,3.49a3.7,3.7,0,0,0,5.24,0l5.67-5.67L18.88,14a.62.62,0,0,0,.37-1.05Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M21,16l-2,4a2.23,2.23,0,0,0,.42,2.6h0a2.25,2.25,0,0,0,3.18,0h0A2.23,2.23,0,0,0,23,20Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M3.5,9.52V3.75a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3V12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path></g></svg>'
    >
      <p
        v-if="$store.getters.getComposerModules.postcard.main.mode === 1"
      >
        <FormInput
          type="checkbox"
          value="1"
          v-model="selectionData.backLogo"
          :checked="selectionData.backLogo"
          :fakeDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min ? false : true"
        >
          <template v-slot:default>
            <div>
              <Badge
                v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min ? false : true"
                :color="'yellow'"
              >
                ab {{ $store.getters.getOrderQtySize.sm.min }} Präsenten
              </Badge>
            </div>

            <b>Branding Grußkarte - Rückseite</b>
            <br>
            <span class="fancy-chooser__description small"><small>+{{ humanPrice($store.getters.getPricesLogoProduct.default_net) }}</small></span>
          </template>

          <template v-slot:after>
            <a @click="$root.$emit('composerModal:open', 'ModalExternalContent', { url: 'https://componata.de/composer-knowledgebase/branding-grusskarte-rueckseite/' })">Beispiel anzeigen</a>
          </template>
        </FormInput>
      </p>

      <p>
        <FormInput
          type="checkbox"
          value="1"
          v-model="selectionData.caseLogo"
          :checked="selectionData.caseLogo"
          :fakeDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.md.min ? false : true"
        >
          <template v-slot:default>
            <div>
              <Badge
                v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.md.min ? false : true"
                :color="'yellow'"
              >
                ab {{ $store.getters.getOrderQtySize.md.min }} Präsenten
              </Badge>
            </div>

            <b>Box-Branding in Schuber</b>
            <br>
            <small>+{{ humanPrice($store.getters.getPricesSchuberProduct.default_net) }}</small>
          </template>

          <template v-slot:after>
            <a @click="$root.$emit('composerModal:open', 'ModalExternalContent', { url: 'https://componata.de/composer-knowledgebase/box-branding-in-schuber/' })">Beispiel anzeigen</a>
          </template>
        </FormInput>
      </p>

      <Notice
          v-if="selectionData.backLogo == 1 || selectionData.caseLogo == 1"
        >
        <p>Senden Sie uns Ihr Logo nach der Bestellung per eMail zu. Bitte verwenden Sie eine möglichst hochauflösende, freigestellte (Vektor-)Grafik.</p>
      </Notice>
    </ModuleSection>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';
import { logicMixin } from '@/mixins/LogicMixin';

import FormInput from '@/components/Common/FormInput';
import ModuleSection from '@/components/Composer/ModuleSection';
import Notice from '@/components/Composer/Notice';
import Badge from '@/components/Composer/Badge';

export default {
  name: 'ModulePostcardAddons',
  mixins: [helperMixin, logicMixin],
  props: ['selectionData'],
  components: {
    FormInput,
    ModuleSection,
    Notice,
    Badge
  }
};
</script>

<style lang="scss" scoped>
/**
 * Postcard Addons
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard's addon options
 * @since 2021-08-31
**/

$component: 'addons';

.#{$component} {

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
